import {request} from './base'

export default {
    getUnHandleCount(data) {
        return request('/common/getUnHandleCount', data, 'get', false)
    },
}
